// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: 'AIzaSyASEGDl431XL669V7U8O-XxJu7vdIlyHEQ',
    authDomain: 'noi-educam-voi-evoluati.firebaseapp.com',
    projectId: 'noi-educam-voi-evoluati',
    storageBucket: 'noi-educam-voi-evoluati.appspot.com',
    messagingSenderId: '1004363779757',
    appId: '1:1004363779757:web:238c921dd111fa5008c024',
    measurementId: 'G-DT6EW0559G'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
